import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from "react";
import { SIcon } from "../components/SIcon";
export const SCardBody = ({ children, className = "" })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: `px-6 my-4 w-full ${className}`,
        children: children
    });
};
const SShimmerLoader = ()=>{
    // return (
    //   <SCardBody>
    //     <SCardBody>
    //       <SScaleLoader />
    //     </SCardBody>
    //   </SCardBody>
    // )
    const rows = 5;
    const columns = 1;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col w-full justify-start items-start gap-0 px-4 pb-1 ",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-row items-center w-full gap-4",
                style: {
                    height: 52
                },
                children: /*#__PURE__*/ _jsx("div", {
                    style: {
                        height: 20,
                        width: "100%",
                        border: "1px solid rgba(255,255,255,0.05)",
                        background: "rgba(255,255,255,0.05)"
                    },
                    className: "self-center flex-grow grow rounded-md mt-3"
                })
            }),
            Array.from(Array(rows).keys()).map((i)=>/*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-row items-center w-full gap-4",
                    style: {
                        height: 49
                    },
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                width: 20,
                                height: 20,
                                border: "1px solid rgba(255,255,255,0.05)",
                                background: "rgba(255,255,255,0.05)"
                            },
                            className: "rounded-full"
                        }),
                        Array.from(Array(columns).keys()).map((i)=>/*#__PURE__*/ _jsx("div", {
                                style: {
                                    height: 20,
                                    border: "1px solid rgba(255,255,255,0.05)",
                                    background: "rgba(255,255,255,0.05)"
                                },
                                className: "self-center flex-grow grow rounded-md"
                            }, `sc-${i}`))
                    ]
                }, `sr-${i}`))
        ]
    });
};
const EmptyView = ()=>{
    const quotes = [
        "In the absence of data, we find clarity in purpose.",
        "No data often means a new path yet to be explored.",
        "When data is scarce, creativity flourishes.",
        "Embrace the emptiness of no data, for it is the canvas of innovation.",
        "Not every search yields results, but every search teaches something.",
        "When we find no data, we're simply at the starting line of discovery.",
        "Data might not always be present, but wisdom is always within reach.",
        "In the void of data, let intuition be your compass.",
        "A lack of data is just an invitation to dig deeper.",
        "No data today, endless possibilities tomorrow."
    ];
    const quote = useMemo(()=>{
        return quotes[Math.floor(Math.random() * quotes.length)];
    }, []);
    const [isHovering, setIsHovering] = useState(false);
    return /*#__PURE__*/ _jsx(SCardBody, {
        children: /*#__PURE__*/ _jsx("p", {
            className: "opacity-50",
            onMouseEnter: ()=>setIsHovering(true),
            onMouseLeave: ()=>setIsHovering(false),
            children: "No data found"
        })
    });
};
export const SDebugInfo = ({ title, data: _code, className = "" })=>{
    // check if window is undefined (SSR)
    // if (typeof window === "undefined") {
    //   return null
    // }
    const code = typeof _code === "string" ? _code : JSON.stringify(_code, null, 2);
    return /*#__PURE__*/ _jsxs(SCardBody, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "my-2 mx-4 text-sm opacity-50",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full text-xs break-all overflow-x-scroll p-4 rounded-md border border-1 border-border-light  bg-grayscale-darker",
                children: /*#__PURE__*/ _jsx("pre", {
                    className: "whitespace-wrap break-all max-w-2xl",
                    children: code
                })
            })
        ]
    });
};
const SCard = ({ header: _header, isLoading: _isLoading, expanded, isEmpty, expandable: _expandable, className = "", children })=>{
    const [isExpanded, setIsExpanded] = useState(expanded);
    const expandable = _expandable === undefined ? isExpanded !== undefined : _expandable;
    const isLoading = _isLoading;
    let header = undefined;
    if (!/*#__PURE__*/ React.isValidElement(_header) && typeof _header === "object") {
        header = _header;
    }
    const hasHeader = !!(header || _header);
    return /*#__PURE__*/ _jsxs("div", {
        className: `bg-grayscale-dark rounded-xl border border-1 border-border-light flex flex-col my-3 mt-3 ${className || ""}`,
        children: [
            _header && /*#__PURE__*/ React.isValidElement(_header) && _header,
            header && /*#__PURE__*/ _jsx("div", {
                className: `gap-0 py-3 pl-4 pr-6 md:py-4 md:px-6 ${expandable ? " select-none" : ""} ${header.className || ""}`,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: `w-full ${header.responsive ? "md:grid md:grid-cols-[1fr,auto]" : "grid grid-cols-[1fr,auto]"} gap-4 items-center justify-between`,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: `w-full grid ${header.icon ? "grid-cols-[auto,1fr]" : "grid-cols-[1fr]"} gap-3 items-center justify-start flex-grow ${expandable ? "cursor-pointer" : ""}`,
                            onClick: ()=>expandable && setIsExpanded(!isExpanded),
                            children: [
                                header.icon && /*#__PURE__*/ _jsx("div", {
                                    className: "flex-shrink-0",
                                    children: header.icon
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-lg relative w-full flex flex-col md:flex-row md:items-center",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                header.title,
                                                " ",
                                                expandable && /*#__PURE__*/ _jsx("div", {
                                                    className: `md:hidden transform opacity-50 cursor-pointer mt-[2px] transition-all ${!isExpanded ? "rotate-0 " : "rotate-90"}`,
                                                    children: /*#__PURE__*/ _jsx(SIcon, {
                                                        size: 20,
                                                        type: "chevron-right"
                                                    })
                                                })
                                            ]
                                        }),
                                        header.subtitle && /*#__PURE__*/ _jsx("span", {
                                            className: "text-sm opacity-50 inline md:ml-2 md:mt-[2px]",
                                            children: header.subtitle
                                        }),
                                        expandable && /*#__PURE__*/ _jsx("div", {
                                            className: `hidden md:block transform opacity-50 mt-[2px] cursor-pointer transition-all ${!isExpanded ? "rotate-0 " : "rotate-90"}`,
                                            children: /*#__PURE__*/ _jsx(SIcon, {
                                                size: 22,
                                                type: "chevron-right"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: `flex flex-row items-center ${header.responsive ? " md:justify-end" : "justify-end "} gap-6`,
                            children: header.accessory
                        })
                    ]
                })
            }),
            hasHeader ? children && (expandable && isExpanded || !expandable) && (isLoading ? /*#__PURE__*/ _jsxs("div", {
                className: "border-t border-1 border-border-light w-full flex items-center justify-center",
                children: [
                    " ",
                    /*#__PURE__*/ _jsx(SShimmerLoader, {})
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                className: "border-t border-1 border-border-light",
                children: isEmpty ? /*#__PURE__*/ _jsx(EmptyView, {}) : children
            })) : isLoading ? /*#__PURE__*/ _jsxs("div", {
                className: "w-full flex items-center justify-center",
                children: [
                    " ",
                    /*#__PURE__*/ _jsx(SShimmerLoader, {})
                ]
            }) : isEmpty ? /*#__PURE__*/ _jsx(EmptyView, {}) : children
        ]
    });
};
export default SCard;
